export enum NotificationType {
    ReactionThanks = 11,
    ReactionLikes = 12,
    ReactionComments = 14,
    ReactionReplyComment = 15,

    PublicationApproved = 20,
    PublicationReproved = 21,
    PublicationBlocked = 22,
    PublicationUnblocked = 23,
    PublicationDenounced = 24,
    PublicationCommentDenounced = 25,

    NewKnowledgeTestInTopic = 30,
    RecommendationTopic = 31,
    RecommendationPub = 32,
    PendingTestsToExecute = 33,

    MentionUserAdded = 40,

    QuestionAnswerReceived = 50,
    QuestionAnswerRequested = 51,
    QuestionFollow = 52,
    QuestionRepass = 53,

    NewFollower = 61,
    FollowingTopicMoved = 62,
    FollowingTopic = 63,
    FollowingAuthor = 64,

    TaskReportPublicatonAbuse = 70,
    TaskReportPublicationAbuseAccept = 71,
    TaskReportPublicationAbuseDenied = 72,
    TaskReportCommentAbuse = 73,
    TaskReportCommentAbuseAccept = 74,
    TaskReportCommentAbuseDenied = 75,
    TaskPublicationForApproval = 76,

    SuggestionListNewItem = 82,

    AwardPublication = 90,
    Badge = 91,
    AwardQuiz = 92,
    TopicEndorsed = 93,
    TopicSpecialistByUser = 94,
    TopicSpecialistByRule = 95,

    CourseEnrollAdded = 100,
    CourseEnrollCanceled = 101,
    CourseItemsAdded = 102,
    CourseEnrollExpires = 103,
    CourseEnrollClosed = 104,
    CourseItemDeleted = 105,
    NewCourses = 106,

    SystemRecommendations = 200,
}

export enum NotificationMainGroupType {
    PublicationAndQuestion, News, Reaction, Moderation, Award, Course, Mention
}

export enum NotificationSubGroupType {
    PublicationAndQuestion_QuestionAnswerOrFollowing,
    PublicationAndQuestion_QuestionMyAnswer,
    Moderation_PubAnalysed,
    Moderation_PubBlockUnblock,
    Moderation_PubOrCommentReportAnalysed,
    Moderation_TaskReportAbuse,
    Moderation_MyPublicationOrCommentDenounced,
    Award_Badge
}

export enum NotificationEmailOption {
    None = 0,
    Immediate = 1,
    Resume = 2
}

export enum NotificationSendOption {
    None = 0,
    NotificationArea = 1,
    EmailImmediate = 2,
    EmailResume = 4,
}

export enum AccountType {
    Undefined = 0,
    Local = 1,
    Saml = 2,
    WebIntegation = 4
}

export enum AccountLoginResult {
    Valid = 0,
    NotFound = 1,
    NonValidUser = 2,
    Inactive = 3,
    AccountExpired = 4,
    IncorretPassword = 5,
    PasswordExpired = 6,
    DuplicateKey = 7,
    NotConfirmed = 8,
    AuthFieldDisabled = 9,
    Lockedout = 10,
    PasswordAttemptWindow = 11,
    NotAgreement = 12,
    AgreementUpdated = 13,
    ResetWindowExpired = 20,
    SecurityStampNotFound = 21,
    QrCodeExpired = 22,
    SecurityStampExpired = 23,
    AzureAdSsoRefused = 24,
    AzureAdSsoUserHasNoPermission = 25,
    Blocked = 26,
    BadSAMLUser = 27,
    CannotCreateOrUpdateUser = 98,
    Failed = 99
}

export enum AccountConfirmationResult {
    Complete = 0,
    NotFound = 1,
    Expired = 2,
    AlreadyConfirmed = 3
}

export enum AccountReconfirmationResult {
    Complete = 0,
    NotFound = 1,
    AlreadyConfirmed = 2,
    Refused = 3
}

export enum PublicationType {
    Post = 1,
    Question = 3,
    Answer = 4,
    Survey = 5,
    Poll = 6,
    List = 7,
    Course = 8,
}

export enum PublicationViewPriority {
    None = 0,
    High = 3
}

export enum PublicationEditPermissions {
    None = 0,
    Partial = 1,
    Full = 2,
}


export enum ParseFileType {
    Image = 0,
    Audio = 1,
    Video = 3
}

export enum AspectRatio {
    Square = 1,
    Wide = 2,
    Portrait = 3
}

export enum UserPhoneType {
    Comercial = 1,
    Residential = 2,
    Mobile = 3
}

export enum UserSocialNetworkType {
    Facebook,
    Instagram,
    Linkedin,
    Twitter
}

export enum UserCredentialType {
    ProfessionQualification = 1,
    AcademicFormation = 2,
    Project = 3,
    Hobby = 4
}


export enum MemberType {
    User = 1,
    Group = 2
}

export enum GroupType {
    UserDefined = 0,
    SystemAllUsers = 1
}

export enum PublicationLikeOption {
    Like = 1,
    Neutral = 0,
    Dislike = -1
}

export enum ListType {
    Favorite = 1,
    SeeLater = 2,
    Liked = 3,
    Custom = 4
}

export enum ApprovalStatus {
    Pending = 0,
    Approved = 1,
    Rejected = 2,
    PendingCognitiveAnalysis = 3,
    Canceled = 4,
    PendingMediaEncode = 5
}

export enum PublicationActionStatus {
    Pending = 0,
    Processed = 1,
    Ignored = 2,
    Canceled = 3
}

export enum PublicationActionType {
    ReportAbuseInPublication = 1,
    ReportAbuseInComment = 2,

    RepassQuestion = 10,
    MaybeYouCanAnswer = 11,

    ApproveSuggestion = 20,
    ApproveWorkflow = 21,

    Unblock = 30
}


export enum FeedType {
    Any = 0,

    Start = 1,

    Answers = 10,

    Following = 21,

    HighlightsNews = 30,
    HighlightsOnHigh = 31,
    HighlightsLatestNews = 32,

    HistoryRecent = 40,
    HistoryLiked = 41,
    HistoryCommented = 42,
    HistoryThanks = 43,
    HistoryShared = 44,

    List = 50,

    MyPublication = 60,
    MyDraft = 61,
    MyAnswers = 62,

    QuestionRecent = 70,
    QuestionToYou = 71,
    QuestionFollowing = 72,

    TaskDenouncement = 80,
    TaskForYourApproval = 81,
    TaskForYourAction = 82,
    TaskGeneralView = 83,
    TaskRequestedByYou = 84,

    Topic = 90,

    UserProfile = 100,
    UserProfileMentions = 101,
    UserProfileThanks = 102,

    CourseItems = 110,
    CourseViewer = 111,
    CourseAutoEnroll = 112,
    CourseEnrolled = 113,
    CourseCompleted = 114,

    PublicationAdmin = 200
}


export enum AbuseReportStatus { None = 0, Checking = 1, Blocked = 2 }

export enum PublicationShareType { Recommendation = 1, Pass = 2 }

export enum TopicWhoDetermineSpecialist { None = 0, UserManager = 1, CorpManager = 2 }
export enum TopicCommonUserApprovalMethod { Never = 0, SuspiciousOnly = 1, NotApprovedAnotherTopic = 2, Always = 3 }
export enum TopicWhoAnalyzesApproval { DefinedUser = 1, ManagerOfPublisher = 2 }

export enum TopicDashboardKnowledgeDatabaseSummaryColumn { Resume, TestBellow50Detail }
export enum TopicDashboardResultsSummaryColumn { Resume, TopicUsers }

export enum FileCognitiveAnalysisReason {
    None = 0,
    ImageAdultClassified = 1,
    ImageRacyClassified = 2
}

export enum PublicationCognitiveAnalysisReason {
    None = 0,
    ExplicitSexualLanguage = 1,
    SuggestedSexualLanguage = 2,
    OffensiveLanguage = 4,
    ImageAdultClassified = 8,
    ImageRacyClassified = 16
}

export enum DynamicSystemRoles {
    None = 0,
    Manager = 1 << 0,
    TopicAdminDelegation = 1 << 1,
    HasOrCanViewCourses = 1 << 2,
    DashboardManager = 1 << 3
}

export enum SystemRoles {
    None = 0,

    Publisher = 1 << 15,
    PublisherVideo = 1 << 14,
    PublisherAdvancedOptions = 1 << 16,

    TestCreator = 1 << 17,
    CourseCreator = 1 << 18,
    TopicCreator = 1 << 19,

    PublicationManager = 1 << 3,
    TopicManager = 1 << 2,
    CourseManager = 1 << 5,
    TrainingManager = 1 << 4,
    UserManager = 1 << 1,
    GameficationManager = 1 << 6,

    PerformanceAnalyst = 1 << 7,

    Administrator = 1 << 0,
    All = ~(~0 << 52)
}

export enum ChangePasswordResult {
    Success = 0,
    OldPasswordNotMatch = 1,
    SamePasswordEntered = 2,
    InvalidRules = 3
}

export enum PublicationVisility {
    None = 0,
    Visible = 1,
    Hidden = 2
}

export enum RelationshipCreationMode {
    Manual = 0,
    MachineLearning = 1
}

export enum BadgeRuleAction {
    CreatePostArticleQuestion = 1,
    AnswerQuestion = 2,
    TestSessionComplete = 3,
    CourseComplete = 4,
    HadPublicationHighlight = 5,
    HadPublicationThanked = 6,
    HadPublicationLikes = 7,
    CourseListComplete = 13,

    RankingMonthTop3 = 8,
    ReachNumberOfRankingPoints = 9,
    AcquireTopicSpecialist = 10,
    GetMinFollowers = 11,
}

export enum BadgeRulePeriod {
    NoDeadline = 1,
    Week = 2,
    Month = 3
}

export enum BadgeRuleFrequence {
    NoLimit = 1,
    Once = 2,
    OncePerPeriod = 3
}

export enum AwardType {
    Post = 1,
    Article = 2,
    Answer = 3,
    ProfileCredential = 4,
    QuizNewSession = 5,
    QuizRevision = 6,
    CourseComplete = 7,
    Badge = 8,
}


export enum KnowledgeTestSelectionMode { Simple = 1, Multi = 2 }

export enum KnowledgeTestDifficultyLevel { NotInitiate = 0, Beginner = 1, Intermediate = 2, Advanced = 3 }

export enum KnowledgeTestImportance { Low = 1, Normal = 2, High = 3 }

export enum KnowledgeTestTrustLevel { Low = 1, Medium = 2, High = 3 }

export enum KnowledgeTestStatus { AvailableToUse = 1, Blocked = 2, WaitingMediaEncode = 3 }

export enum UserKnowsAboutSpecialistGrantMethod { None = 0, TopicManager = 1, TopicRules = 2, UserManager = 3 }

export enum MediaServicesProcessingStatus {
    Done = 0,
    CreatingJob = 1,
    WaitingJob = 2,
    Failed = 3,
    Deleted = 4
}

export enum QueueViewStatus {
    Unset = 0,
    Pending = 1,
    Done = 2,
    Failed = 4
}

export enum IntegrationQueueEvent {
    CourseEnrolled = 100,
    CourseAccess = 101,
    CourseChangeProgress = 102,
    CourseCanceled = 103,
    KnowledgeSessionResult = 200,
}

export enum CourseItemStatus {
    Active = 0,
    Deleted = 1,
    MarkToDelete = 2,
    MarkToInsert = 3
}

export enum QueueEventType {
    Unset = 0,
    Mail = 1,
    CloudNotification = 2
}

export enum JobLogStatus {
    Unset = 0,
    Running = 1,
    Enqueued = 2,
    FinishedSuccessfully = 3,
    FinishedWithError = 4,
    Canceled = 5
}

export enum JobLogEventType {
    Unset = 0,
    IA = 1,
    Others = 2,
}

export enum TenantBillingType {
    ActiveUsers = 2,
    LicensedUsers = 3
}